import React, { useState, useEffect } from 'react';
import apiService from '../config';
import { Send, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../StoreContext/LanguageContext';

const Railway20ANotification = () => {
  const [lang, setLang] = useState("mr");
  const [showSendToProjectInchargeModal, setshowSendToProjectInchargeModal] = useState(false);
  const [selectedUserProjectIncharge, setselectedUserProjectIncharge] = useState('');
  const [requestedFundPI, setRequestedFundPI] = useState('');
  const [selectedDocumentProjectIncharge, setselectedDocumentProjectIncharge] = useState(null);
  const [datePI, setDatePI] = useState('');
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [selectedSectionType, setSelectedSectionType] = useState(null);
  const [sendingToProjectIncharge, setsendingToProjectIncharge] = useState(false);
  const [remarksProjectIncharge, setremarksProjectIncharge] = useState('Approved');
  const [hasSentToProjectIncharge, setHasSentToProjectIncharge] = useState(false);
  const { language, translations } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [loadingusersProjectIncharge, setLoadingusersProjectIncharge] = useState(false);
  const [usersProjectInchargeAll, setusersProjectInchargeAll] = useState([]);
  const [loadingusersLAO, setLoadingusersLAO] = useState(false);
  const [usersLAO, setusersLAO] = useState([]);
  const [showSendBackButton, setShowSendBackButton] = useState({});

  const handleSendToProjectIncharge = async () => {
    if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge || !requestedFundPI || !datePI) {
      alert('Please fill in all required fields');
      return;
    }

    if (!currentProjectId || !proposalId) {
      alert('Project ID or Proposal ID not available');
      return;
    }

    if (!selectedSectionType) {
      alert('Section type not specified');
      return;
    }

    setsendingToProjectIncharge(true);
    try {
      const fundData = new FormData();
      fundData.append('project_id', currentProjectId);
      fundData.append('proposal_id', proposalId);
      fundData.append('requested_fund', requestedFundPI);
      fundData.append('received_fund', '0');
      fundData.append('date', datePI);
      fundData.append('type', selectedSectionType); // Add type here

      if (selectedDocumentProjectIncharge) {
        fundData.append('document', selectedDocumentProjectIncharge);
      }

      // Call appropriate API based on section
      if (selectedSectionType === 'section11') {
        await apiService.postAddFundRequestReceivedSection11(fundData);
      } else if (selectedSectionType === 'section19') {
        await apiService.postAddFundRequestReceivedSection19(fundData);
      }

      const trackingData = new FormData();
      trackingData.append('project_id', currentProjectId);
      trackingData.append('proposal_id', proposalId);
      trackingData.append('usr_id', selectedUserProjectIncharge);
      trackingData.append('remarks', remarksProjectIncharge);
      trackingData.append('document', selectedDocumentProjectIncharge);

      // Different tracking name based on section
      const trackingName = selectedSectionType === 'section11'
        ? 'ProjectInchargeFundSection11'
        : 'ProjectInchargeFundSection19';

      await apiService.postTrackingSendToProjectIncharge(trackingData, trackingName);

      alert(`Successfully sent to Project Incharge (${selectedSectionType})!`);

      setHasSentToProjectIncharge(true);
      setshowSendToProjectInchargeModal(false);
      setselectedUserProjectIncharge('');
      setremarksProjectIncharge('Approved');
      setselectedDocumentProjectIncharge(null);
      setRequestedFundPI('');
      setDatePI('');
      setSelectedSectionType(null); // Reset

      fetchFundData();
      localStorage.setItem(`fundSent_${proposalId}`, 'true');
    } catch (error) {
      console.error('Error sending to Project Incharge:', error);
      alert('Failed to send to Project Incharge');
    } finally {
      setsendingToProjectIncharge(false);
    }
  };
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return { id: projectId, name: projectName };
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
  }, []);

  useEffect(() => {
    const savedProposalId = localStorage.getItem('currentProposalId');
    if (savedProposalId) {
      setProposalId(savedProposalId);
    }
  }, []);

  useEffect(() => {
    if (currentProjectId && proposalId) {
      const wasSent = localStorage.getItem(`fundSent_${proposalId}`) === 'true';
      setHasSentToProjectIncharge(wasSent);
      fetchFundData();
      fetchProjectInchargeUsers();
      fetchLAOUsers();
    }
  }, [currentProjectId, proposalId]);

  useEffect(() => {
    if (currentProjectId && proposalId) {
      const wasSent = localStorage.getItem(`fundSent_${proposalId}`) === 'true';
      setHasSentToProjectIncharge(wasSent);

      // ADD THESE LINES:
      // const sentSection11 = localStorage.getItem(`fundSentToLAO_Section11_${proposalId}`) === 'true';
      // const sentSection19 = localStorage.getItem(`fundSentToLAO_Section19_${proposalId}`) === 'true';
      // setSentToLAOSection11(sentSection11);
      // setSentToLAOSection19(sentSection19);

      fetchFundData();
      fetchProjectInchargeUsers();
      fetchLAOUsers();
    }
  }, [currentProjectId, proposalId]);

  const fetchFundData = async () => {
    if (!currentProjectId || !proposalId) {
      console.warn('Project ID or Proposal ID not available');
      return;
    }

    setLoading(true);
    try {

      // Combined sendBackStatus - Changed from .id to .fund_id
      const sendBackStatus = {};

      setShowSendBackButton(sendBackStatus);

    } catch (error) {
      console.error('Error fetching fund data:', error);
      alert('Failed to fetch fund data');
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectInchargeUsers = async () => {
    setLoadingusersProjectIncharge(true);
    try {
      const response = await apiService.getAllUserRoleProjectIncharge(18);
      setusersProjectInchargeAll(response.data || []);
    } catch (error) {
      console.error('Error fetching Project Incharge users:', error);
    } finally {
      setLoadingusersProjectIncharge(false);
    }
  };

  const fetchLAOUsers = async () => {
    setLoadingusersLAO(true);
    try {
      const response = await apiService.getRailwayLAOButton(3);
      setusersLAO(response.data || []);
    } catch (error) {
      console.error('Error fetching LAO users:', error);
    } finally {
      setLoadingusersLAO(false);
    }
  };


  /* ===================== DATA (API-READY STRUCTURE) ===================== */
  const DATA = {
    notification20A: {
      mr: {
        heading: "अधिसूचना 20(A)",
        subHeading: "रेल्वे दुरुस्ती कायदा 2008 मधिल कलम 20(A)/20(D) अंतर्गत अधिसुचना",
        engSubHeading: "(THE RAILWAYS (AMENDMENT ACT 2008) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/20(D)",
        officeRef: "क्र.कावि/अ.का.भु.सं./       /2023",
        officeName: "उपविभागीय अधिकारी तथा भुसंपादन अधिकारी",
        officeLocation: "जळगांव जा. कार्यालय",
        date: "दिनांक:- 07/12/2023",

        paragraphs: [
          "ज्याअर्थी, मा.जिल्हाधिंकारी,बुलडाणा यांचे आदेश क्र.कावि/कक्ष-/प्रअभुसं./429/2023 दि. 11 एप्रिल 2023 चे आदेश व रेल्वे दुरुस्ती कायदा 2008 (THE RAILWAYS (AMENDMENT ACT 2008)मधिल कलम 20(A) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/ 20(D) मधिल निर्देशानुसार अकोला-खंडवा ब्रॉडगेज रेल्वे प्रकल्पांतर्गत उक्त भुसंपादन प्रकरणात भुसंपादनाची कार्यवाही करण्यासंबंधि कार्यकारी अभियंता,दक्षीण मध्य रेल्वे बांधकाम-2 अकोला यांचा प्रस्ताव व रेल्वे दुरुस्ती कायदा 2008 मधिल तरतुदीनुसार रेल्वे प्रकल्पासाठी प्राप्त भुसंपादन प्रस्तावानुसार (Chif Administrative Officer(Construction) South Central Railway /Secunderabad's dated 25.04.2023 अन्वये उपविभागीय अधिकारी तथा भुसंपादन अधिकारी,जळगांव जा.यांना (CALA) म्हणुन भुसंपादन प्रक्रिया करण्यासाठी प्राधिकृत केलेले आहे.त्यासंबंधिची अधिसुचना प्रसिध्द केली आहे.तसेच मा.जिल्हाधिकारी,बुलडाणा यांनी उक्त आदेशान्वये भुसंपादनाची कार्यवाही करण्यासंबंधि उपविभागीय अधिकारी तथा भुसंपादन अधिकारी,जळगांव जा.यांना आदेशित करुन प्राधिकृत केले आहे.",

          "ज्याअर्थि, मला प्रदान केलेल्या अधिकाराचा वापर करुन,उक्त रेल्वे सुधारणा अधिनियम 2008 चे कलम 20(A)/ 20(D) संबंधिची प्राथमिक अधिसुचनेअंतर्गत अकोला-खंडवा ब्रॉडगेज परिवर्तन प्रस्तावित ब्रॉडगेज प्रकल्पामुळे दळणवळण सुधारणाबरोबरच रोजगारही वाढ होणे अपेक्षित असल्याने (आर्थिक,रोजगार,पायाभुत सुविधा, सोई सुविधा याबाबत व इतर लाभासंबंधात )सार्वजनिक हितार्थ सदरची अधिसुचना 20(A)/ 20(D) रेल्वे प्रकल्पाकरीता प्रस्तावित व संयुक्त मोजणी अहवालानुसार भुसंपादीत जमीनीच्या तपशिलासह सार्वजनिकरित्या भारत सरकारचे राजपत्र,राज्य शासनाचे राजपत्र, स्थानिक वृत्तपत्र व संबंधित कार्यालयाचे ठिकाणी व जमीनीचा संबंध असलेल्या गावाच्या तलाठी चावडी व ग्रामपंचायत कार्यालयावर प्रसिध्द करण्यात येत आहे.",

          "त्याअर्थि, रेल्वे सुधारणा अधिनियम 2008 चे कलम 20(A) ची अधिसुचना संयुक्त मोजणी अहवालानुसार प्रसिध्द करण्यासंदर्भात व कलम 20(D) मधिल तरतुदीनुसार सदरची अधिसुचना उक्त ठिकाणी प्रसिध्द झाल्यापासुन 30 दिवस मुदतीत, उपविभागीय अधिकारी तथा भुसंपादन अधिकारी,जळगांव जा.यांचे कार्यालयात संबंधित भुधारकास भुसंपादन विषयक आक्षेप/हरकती दाखल करण्याची तरतुद असल्याने संबंधित भुधारकाने अथवा त्याचे अभियोक्ता मार्फत आक्षेप अथवा हरकती विहीत मुदतीत दाखल करण्याची तरतुद असुन विहीत मुदतीत आक्षेप अथवा हरकती प्राप्त न झाल्यास भुसंपादनाची कार्यवाही उक्त अधिनियमाच्या अंतर्गत करण्यात येईल."
        ],

        schedule1: "अनुसुची-एक",
        schedule1Desc: "भुसंपादीत जमीनीचे वर्णन:- अकोला-खंडवा ब्रॉडगेज परिवर्तन रेल्वे प्रकल्प या प्रकल्पांतर्गत प्रवासी व मालवाहतुक सुविधा कामासाठी",

        schedule2: "अनुसुची – दोन",
        schedule2Title: "सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण",
        schedule2Data: {
          projectName: "प्रकल्पाचे नांव:- अकोला खंडवा ब्रॉडगेज परिवर्तन रेल्वे प्रकल्प ता.जळगांव जा.जि.बुलडाणा या प्रकल्पाअंतर्गत प्रवासी व मालवाहतुक सुविधा कामासाठी",
          acquisitionAgency: "संपादन यंत्रणेचा तपशील:- कार्यकारी अभियंता,दक्षीण मध्य रेल्वे बांधकाम-2 अकोला",
          socialBenefits: "समाजाला मिळणारे लाभ:- अकोला-खंडवा ब्रॉडगेज परिवर्तन प्रस्तावित ब्रॉडगेज प्रकल्पामुळे दळणवळण सुधारण्या बरोबरच रोजगारात ही वाढ होणे अपेक्षित आहे.(आर्थिक,रोजगार,पायाभूत सुविधा, सोयी सुविधा या बाबत व इतर लाभा संबंधात )"
        },

        village: "गांव",
        taluka: "तालुका",
        district: "जिल्हा",

        tableHeaders: [
          "अ.क्र.",
          "सर्व्हे/गट क्र.",
          "7/12 प्रमाणे एकुण क्षेत्र हे.आर. (वहीती योग्य)",
          "7/12 प्रमाणे एकुण क्षेत्र हे.आर. (पोटखराब)",
          "7/12 प्रमाणे एकुण क्षेत्र हे.आर. (एकुण)",
          "संयुक्त मोजणी अहवालनुसार संपादन क्षेत्र हे.आर. (वहीती योग्य)",
          "संयुक्त मोजणी अहवालनुसार संपादन क्षेत्र हे.आर. (पोट खराब)",
          "संयुक्त मोजणी अहवालनुसार संपादन क्षेत्र हे.आर. (एकुण)",
          "7/12 प्रमाणे भुधारकाचे नांव"
        ],

        signature: "(शैलेष काळे)",
        designation: "उपविभागीय अधिकारी,तथा भुसंपादन अधिकारी,जळगांव जा."
      },

      hi: {
        heading: "अधिसूचना 20(A)",
        subHeading: "रेलवे संशोधन अधिनियम 2008 की धारा 20(A)/20(D) के अंतर्गत अधिसूचना",
        engSubHeading: "(THE RAILWAYS (AMENDMENT ACT 2008) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/20(D)",
        officeRef: "क्रमांक कावि/अ.का.भु.सं./       /2023",
        officeName: "उपविभागीय अधिकारी तथा भूमि अधिग्रहण अधिकारी, जलगाँव जा. कार्यालय",
        date: "दिनांक:- 07/12/2023",

        paragraphs: [
          "जिसके अर्थ में, मा.जिल्हाधिकारी, बुलढाणा के आदेश क्र.कावि/कक्ष-/प्रअभुसं./429/2023 दि. 11 अप्रैल 2023 के आदेश और रेलवे संशोधन अधिनियम 2008 (THE RAILWAYS (AMENDMENT ACT 2008) की धारा 20(A) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/ 20(D) के निर्देशानुसार अकोला-खंडवा ब्रॉडगेज रेलवे परियोजना के अंतर्गत उक्त भूमि अधिग्रहण मामले में भूमि अधिग्रहण की कार्यवाही करने के संबंध में कार्यकारी अभियंता, दक्षिण मध्य रेलवे निर्माण-2 अकोला का प्रस्ताव और रेलवे संशोधन अधिनियम 2008 की प्रावधानों के अनुसार रेलवे परियोजना के लिए प्राप्त भूमि अधिग्रहण प्रस्ताव के अनुसार (Chief Administrative Officer (Construction) South Central Railway /Secunderabad's dated 25.04.2023 के अनुसार उपविभागीय अधिकारी तथा भूमि अधिग्रहण अधिकारी, जलगाँव जा. को (CALA) के रूप में भूमि अधिग्रहण प्रक्रिया करने के लिए अधिकृत किया गया है। इसके संबंध में अधिसूचना प्रकाशित की गई है। साथ ही मा.जिल्हाधिकारी, बुलढाणा ने उक्त आदेश के अनुसार भूमि अधिग्रहण की कार्यवाही करने के संबंध में उपविभागीय अधिकारी तथा भूमि अधिग्रहण अधिकारी, जलगाँव जा. को आदेशित करके अधिकृत किया है।",

          "जिसके अर्थ में, मुझे प्रदान किए गए अधिकार का उपयोग करते हुए, उक्त रेलवे सुधार अधिनियम 2008 की धारा 20(A)/ 20(D) से संबंधित प्रारंभिक अधिसूचना के अंतर्गत अकोला-खंडवा ब्रॉडगेज परिवर्तन प्रस्तावित ब्रॉडगेज परियोजना के कारण संचार सुधार के साथ-साथ रोजगार में भी वृद्धि होने की अपेक्षा है (आर्थिक, रोजगार, बुनियादी सुविधाएं, सुविधा सुविधाओं के बारे में और अन्य लाभों के संबंध में) सार्वजनिक हित के लिए उक्त अधिसूचना 20(A)/ 20(D) रेलवे परियोजना के लिए प्रस्तावित और संयुक्त माप रिपोर्ट के अनुसार अधिग्रहित भूमि के विवरण के साथ सार्वजनिक रूप से भारत सरकार के राजपत्र, राज्य सरकार के राजपत्र, स्थानीय समाचार पत्र और संबंधित कार्यालय के स्थान पर और भूमि से संबंधित गांव के तलाठी चावडी और ग्राम पंचायत कार्यालय पर प्रकाशित की जा रही है।",

          "इसके अर्थ में, रेलवे सुधार अधिनियम 2008 की धारा 20(A) की अधिसूचना संयुक्त माप रिपोर्ट के अनुसार प्रकाशित करने के संदर्भ में और धारा 20(D) की प्रावधानों के अनुसार उक्त अधिसूचना उक्त स्थान पर प्रकाशित होने से 30 दिन की अवधि में, उपविभागीय अधिकारी तथा भूमि अधिग्रहण अधिकारी, जलगाँव जा. के कार्यालय में संबंधित भूमिधारक को भूमि अधिग्रहण विषयक आपत्ति/हर्जाना दर्ज करने का प्रावधान है इसलिए संबंधित भूमिधारक या उसके अभियुक्त के माध्यम से आपत्ति या हर्जाना निर्धारित अवधि में दर्ज करने का प्रावधान है और निर्धारित अवधि में आपत्ति या हर्जाना प्राप्त नहीं होने पर भूमि अधिग्रहण की कार्यवाही उक्त अधिनियम के अंतर्गत की जाएगी।"
        ],

        schedule1: "अनुसूची-एक",
        schedule1Desc: "अधिग्रहित भूमि का विवरण:- अकोला-खंडवा ब्रॉडगेज परिवर्तन रेलवे परियोजना इस परियोजना के अंतर्गत यात्री और माल परिवहन सुविधा कार्य के लिए",

        schedule2: "अनुसूची – दो",
        schedule2Title: "सार्वजनिक उद्देश्य के स्वरूप के बारे में विवरण",
        schedule2Data: {
          projectName: "परियोजना का नाम:- अकोला खंडवा ब्रॉडगेज परिवर्तन रेलवे परियोजना ता.जलगाँव जा.जि.बुलढाणा इस परियोजना के अंतर्गत यात्री और माल परिवहन सुविधा कार्य के लिए",
          acquisitionAgency: "अधिग्रहण तंत्र का विवरण:- कार्यकारी अभियंता, दक्षिण मध्य रेलवे निर्माण-2 अकोला",
          socialBenefits: "समाज को मिलने वाले लाभ:- अकोला-खंडवा ब्रॉडगेज परिवर्तन प्रस्तावित ब्रॉडगेज परियोजना के कारण संचार सुधार के साथ-साथ रोजगार में भी वृद्धि होने की अपेक्षा है। (आर्थिक, रोजगार, बुनियादी सुविधाएं, सुविधा सुविधाओं के बारे में और अन्य लाभों के संबंध में)"
        },

        village: "गाँव",
        taluka: "तालुका",
        district: "जिला",

        tableHeaders: [
          "क्रमांक",
          "सर्वे/गट नं.",
          "7/12 के अनुसार कुल क्षेत्र हे.आर. (वहीती योग्य)",
          "7/12 के अनुसार कुल क्षेत्र हे.आर. (पोटखराब)",
          "7/12 के अनुसार कुल क्षेत्र हे.आर. (कुल)",
          "संयुक्त माप रिपोर्ट के अनुसार अधिग्रहित क्षेत्र हे.आर. (वहीती योग्य)",
          "संयुक्त माप रिपोर्ट के अनुसार अधिग्रहित क्षेत्र हे.आर. (पोट खराब)",
          "संयुक्त माप रिपोर्ट के अनुसार अधिग्रहित क्षेत्र हे.आर. (कुल)",
          "7/12 के अनुसार भूमिधारक का नाम"
        ],

        signature: "(शैलेष काळे)",
        designation: "उपविभागीय अधिकारी, तथा भूमि अधिग्रहण अधिकारी, जलगाँव जा."
      },

      en: {
        heading: "Notification 20(A)",
        subHeading: "Notification under Section 20(A)/20(D) of the Railways Amendment Act 2008",
        engSubHeading: "(THE RAILWAYS (AMENDMENT ACT 2008) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/20(D)",
        officeRef: "Ref. No. Kavi/A.Ka.Bhu.San./       /2023",
        officeName: "Office of Sub-Divisional Officer & Land Acquisition Officer, Jalgaon Ja.",
        date: "Date:- 07/12/2023",

        paragraphs: [
          "Whereas, as per the orders of Hon. District Collector, Buldana Order No. Kavi/Kaksh-/PrAbhusan./429/2023 dated 11th April 2023 and as per the directives of Section 20(A) POWER TO ACQUIRED LAND NOTIFICATION OF 20(A)/ 20(D) of the Railways Amendment Act 2008 (THE RAILWAYS (AMENDMENT ACT 2008), regarding the land acquisition proceedings in the said land acquisition case under the Akola-Khandwa Broad Gauge Railway Project, the proposal of Executive Engineer, South Central Railway Construction-2 Akola and as per the land acquisition proposal received for the Railway Project as per the provisions of the Railways Amendment Act 2008 (Chief Administrative Officer (Construction) South Central Railway /Secunderabad's dated 25.04.2023, the Sub-Divisional Officer & Land Acquisition Officer, Jalgaon Ja. has been authorized as (CALA) to carry out the land acquisition process. The notification regarding this has been published. Also, Hon. District Collector, Buldana has ordered and authorized the Sub-Divisional Officer & Land Acquisition Officer, Jalgaon Ja. to carry out the land acquisition proceedings as per the said order.",

          "Whereas, using the authority granted to me, under the preliminary notification related to Section 20(A)/ 20(D) of the said Railway Improvement Act 2008, the proposed Akola-Khandwa Broad Gauge conversion Broad Gauge project is expected to improve communication as well as increase employment (regarding economic, employment, infrastructure, convenience facilities and other benefits), for public interest, the said notification 20(A)/ 20(D) is being published publicly for the Railway Project along with the details of the acquired land as per the joint measurement report in the Government of India Gazette, State Government Gazette, local newspapers and at the concerned office location and at the Talathi Chavdi and Gram Panchayat office of the village concerned with the land.",

          "Therefore, regarding the publication of the notification of Section 20(A) of the Railway Improvement Act 2008 as per the joint measurement report and as per the provisions of Section 20(D), within 30 days from the date of publication of the said notification at the said place, the concerned landowner has provision to file objections/complaints regarding land acquisition at the office of Sub-Divisional Officer & Land Acquisition Officer, Jalgaon Ja. Therefore, the concerned landowner or through his prosecutor has provision to file objections or complaints within the prescribed period and if objections or complaints are not received within the prescribed period, land acquisition proceedings will be carried out under the said Act."
        ],

        schedule1: "Schedule-I",
        schedule1Desc: "Description of Acquired Land:- Akola-Khandwa Broad Gauge Conversion Railway Project for passenger and freight transport facility works under this project",

        schedule2: "Schedule – II",
        schedule2Title: "Details regarding the nature of public purpose",
        schedule2Data: {
          projectName: "Project Name:- Akola Khandwa Broad Gauge Conversion Railway Project Ta.Jalgaon Ja.Dist.Buldana for passenger and freight transport facility works under this project",
          acquisitionAgency: "Details of Acquisition Agency:- Executive Engineer, South Central Railway Construction-2 Akola",
          socialBenefits: "Benefits to Society:- The proposed Akola-Khandwa Broad Gauge conversion Broad Gauge project is expected to improve communication as well as increase employment. (Regarding economic, employment, infrastructure, convenience facilities and other benefits)"
        },

        village: "Village",
        taluka: "Taluka",
        district: "District",

        tableHeaders: [
          "Sr.No",
          "Survey/Gut No",
          "Total Area as per 7/12 Hec.Ar. (Cultivable)",
          "Total Area as per 7/12 Hec.Ar. (Uncultivable)",
          "Total Area as per 7/12 Hec.Ar. (Total)",
          "Acquired Area as per Joint Measurement Report Hec.Ar. (Cultivable)",
          "Acquired Area as per Joint Measurement Report Hec.Ar. (Uncultivable)",
          "Acquired Area as per Joint Measurement Report Hec.Ar. (Total)",
          "Name of Landowner as per 7/12"
        ],

        signature: "(Shailesh Kale)",
        designation: "Sub-Divisional Officer & Land Acquisition Officer, Jalgaon Ja."
      }
    },

    notification20D: {
      mr: {
        heading: "अधिसूचना 20(D)",
        paragraphs: [
          "या अधिसूचनेच्या प्रकाशनापासून 30 दिवसांच्या आत हरकती सादर करता येतील.",
          "विहित मुदतीत हरकती प्राप्त न झाल्यास पुढील भूसंपादन कार्यवाही करण्यात येईल."
        ]
      },
      hi: {
        heading: "अधिसूचना 20(D)",
        paragraphs: [
          "इस अधिसूचना के प्रकाशन से 30 दिनों के भीतर आपत्तियाँ दर्ज की जा सकती हैं।",
          "निर्धारित अवधि में आपत्तियाँ प्राप्त नहीं होने पर आगे की भूमि अधिग्रहण कार्यवाही की जाएगी।"
        ]
      },
      en: {
        heading: "Notification 20(D)",
        paragraphs: [
          "Objections may be submitted within 30 days from the date of publication of this notification.",
          "If objections are not received within the prescribed period, further land acquisition proceedings will be carried out."
        ]
      }
    },

    villages: [
      {
        caseNo: {
          mr: "1) भुसंपादन प्रकरण क्रमांक एलएक्यु-47/07 लोहगांव खु./2022-23(सं.मो.अ.नुसार)कलम20(A)/20(D) अधिसुचना.",
          hi: "भूमि अधिग्रहण प्रकरण क्रमांक एलक्यु-47/07 लोहगांव खु./2022-23(सं.मो.अ.अनुसार)धारा20(A)/20(D) अधिसूचना।",
          en: "Land Acquisition Case No. LAQ-47/07 Lohgaon Khu./2022-23 (As per J.M.R.) Section 20(A)/20(D) Notification."
        },
        name: { mr: "लोहगांव खु.", hi: "लोहगांव खु.", en: "Lohgaon Khu." },
        taluka: { mr: "संग्रामपुर", hi: "संग्रामपुर", en: "Sangrampur" },
        district: { mr: "बुलडाणा", hi: "बुलढाणा", en: "Buldana" },
        rows: [
          ["1", "27", "1.03", "0.00", "2.87", "0.57", "0.00", "1.13", "मुरलीधर काशिराम भातुरकर"],
          ["2", "27", "0.81", "0.00", "2.87", "0.56", "0.00", "1.13", "राजाराम गुलाबराव घुमरे"],
          ["3", "27", "1.00", "0.03", "2.87", "0.00", "0.00", "1.13", "राजेश पांडुरंग भातुरकर"],
          ["4", "26", "0.30", "0.00", "0.30", "0.118", "0.00", "0.118", "शुभांगी शांताराम घुमरे"],
          ["5", "33", "1.55", "0.01", "4.88", "0.00", "0.00", "2.124", "वसंत हिरु मुझल्दा"],
          ["6", "33", "0.88", "0.00", "4.88", "0.113", "0.00", "2.124", "शंकर अमरसिंग डाबर"],
          ["7", "33", "2.40", "0.04", "4.88", "1.971", "0.04", "2.124", "क्षितीज रविंद्र वर्गे अपाक वडील राजेंद्र वर्गे"],
          ["8", "0", "0.00", "0.164", "0.164", "0.00", "0.164", "0.164", "नाला"],
          ["एकुण", "", "7.97", "0.244", "8.214", "3.332", "0.204", "3.536", ""]
        ]
      },
      {
        caseNo: {
          mr: "1) भुसंपादन प्रकरण क्रमांक एलएक्यु-47/06 करमोडा/2022-23(सं.मो.अ.नुसार)कलम20(A)/20(D) अधिसुचना.",
          hi: "भूमि अधिग्रहण प्रकरण क्रमांक एलक्यु-47/06 करमोडा/2022-23(सं.मो.अ.अनुसार)धारा20(A)/20(D) अधिसूचना।",
          en: "Land Acquisition Case No. LAQ-47/06 Karmoda/2022-23 (As per J.M.R.) Section 20(A)/20(D) Notification."
        },
        name: { mr: "करमोडा", hi: "करमोडा", en: "Karmoda" },
        taluka: { mr: "संग्रामपुर", hi: "संग्रामपुर", en: "Sangrampur" },
        district: { mr: "बुलडाणा", hi: "बुलढाणा", en: "Buldana" },
        rows: [
          ["1", "64", "1.61", "0.01", "3.27", "0.117", "0.00", "1.721", "वासुदेव नामदेव दांडगे"],
          ["2", "64", "1.62", "0.03", "3.27", "1.574", "0.03", "1.721", "दुवालसिंग शहदरसिंग डाबर"],
          ["3", "62", "1.00", "0.04", "2.95", "1.054", "0.04", "2.98", "सागर वसंत धर्मे"],
          ["4", "62", "1.00", "0.04", "2.95", "0.996", "0.04", "2.98", "विजय वसंत धर्मे"],
          ["5", "62", "0.91", "0.04", "2.95", "0.89", "0.04", "2.98", "वसंत पुंजाजी धर्मे"],
          ["6", "0", "0", "0", "0", "0.00", "0.216", "0.216", "नाला"],
          ["7", "63", "1.60", "0.00", "4.14", "3.89", "0.00", "3.89", "बाळु महादेव वानेरे"],
          ["8", "63", "0.40", "0.00", "4.14", "3.89", "0.00", "3.89", "निलेश बाळु वानेरे अपाक व.बाळु"],
          ["9", "63", "0.65", "0.00", "4.14", "3.89", "0.00", "3.89", "महादेव विठु वानेरे"],
          ["10", "63", "1.48", "0.01", "4.14", "3.89", "0.00", "3.89", "नर्मदा महादेव वानेरे"],
          ["11", "61", "1.62", "0.00", "1.62", "0.16", "0.00", "0.16", "रत्नप्रभाबाई ज.समाधान वर्गे"],
          ["12", "67", "0.81", "0.00", "2.89", "0.00", "0.00", "", "बबन त्रंबक भिसे"],
          ["13", "67", "0.87", "0.00", "2.89", "0.00", "0.00", "", "अमोल बबन भिसे"],
          ["14", "67", "0.61", "0.00", "2.89", "0.36", "0.00", "0.36", "राजु खुमसिंग माळी"],
          ["15", "67", "0.60", "0.00", "2.89", "0.727", "0.00", "0.727", "रायसिंग खुमसिंग माळी"],
          ["16", "67", "0.00", "0.00", "2.89", "0.00", "0.156", "0.156", "नाला"],
          ["17", "91", "0.00", "5.02", "5.02", "0.00", "0.649", "0.739", "सरकार"],
          ["18", "91", "0.00", "0.00", "5.02", "0.00", ".0.09", "0.739", "रोड"],
          ["19", "92", "0.88", "0.00", "3.7", "0.109", "0.00", "0.784", "आशाबाई सुरेश भातुरकर व इतर 2"],
          ["20", "92", "1.61", "0.00", "3.7", "0.269", "0.00", "0.784", "शांताराम शालीग्राम घुमरे"],
          ["21", "92", "1.21", "0.00", "3.7", "0.406", "0.00", "0.784", "राजु हिरला डावर"],
          ["22", "101", "0.81", "0.00", "2.94", "0.24", "0.00", "1.022", "रामभाऊ ज्ञानेश्वर तराळे"],
          ["23", "101", "0.80", "0.09", "2.94", "0.681", "0.101", "1.022", "सुमित दिपक भातुरकर अपाक आई प्रतिभा"],
          ["23", "101", "0.80", "0.01", "2.94", "0.681", "0.101", "1.022", "मनिष दिपक भातुरकर अपाक आई प्रतिभा"],
          ["23", "101", "0.42", "0.01", "2.94", "0.681", "0.101", "1.022", "दिपक अंबादास भातुरकर"],
          ["24", "100", "1.86", "0.00", "3.72", "0.62", "0.00", "0.62", "आशिष दिलीप घुमरे व इतर 4"],
          ["", "100", "0.40", "0.00", "3.72", "0.00", "0.00", "0.62", "सुमन किसन घुमरे"],
          ["", "100", "1.46", "0.00", "3.72", "0.00", "0.00", "0.62", "परमेश्वर जनार्धन वर्गे"],
          ["25", "99", "0.56", "0.00", "2.26", "1.47", "0.00", "1.47", "नंदाबाई ज.प्रल्हाद कराळे"],
          ["", "99", "0.57", "0.00", "2.26", "1.47", "0.00", "1.47", "रामकृष्ण रामराव वर्गे"],
          ["", "99", "0.07", "0.00", "2.26", "1.47", "0.00", "1.47", "आनंदा शेषराव वर्गे गणेश शेषराव"],
          ["", "99", "0.50", "0.00", "2.26", "1.47", "0.00", "1.47", "कैलास प्रल्हाद कराळे"],
          ["", "99", "0.56", "0.00", "2.26", "1.47", "0.00", "1.47", "राहुल हरीदास वर्गे"],
          ["", "59", "1.43", "0.07", "4.21", "0.167", "0.00", "0.167", "नामदेव तुकाराम दामधर"],
          ["", "59", "1.70", "0.00", "4.21", "0.00", "0.00", "0.167", "संतोष महादेव वानेरे"],
          ["", "59", "0.40", "0.00", "4.21", "0.00", "0.00", "0.167", "वेदांत संतोष वानेरे अपाक वडील"],
          ["", "59", "0.61", "0.00", "4.21", "0.00", "0.00", "0.167", "सुनंदाबाई प्रल्हाद कराळे"],
          ["एकुण", "", "31.43", "5.59", "3.72", "13.73", "1.282", "15.012", ""]
        ]
      }
    ],

    /* ===== Marathi-only letter (LANGUAGE LOCK) ===== */
    officeLetter: {
      heading: "उपविभागीय अधिकारी यांचे कार्यालय, जळगांव जामोद जि.बुलडाणा",
      emailPhone: "Email id- rojalgaonj027@gmail.com दुरध्वनी क्र.07266-221429",
      refNo: "क्र.उविअजजा/अ.का./भुसंपादन/कावि/       /2023",
      date: "दिनांक:-07/12/2023",

      recipients: [
        "प्रति,",
        "1.व्यवस्थापक, शासकिय मुद्रणालय,नागपुर.",
        "2.जिल्हा माहिती अधिकारी,बुलडाणा."
      ],

      subject: [
        "विषय:- अकोला-खंडवा ब्रॉडगेज रेल्वे प्रकल्पाअंतर्गत रेल्वे अधिनियम 1989 (24) अंतर्गत रेल्वे सुधारणा",
        "अधिनियम 2008 चे कलम 20 (A)/20(D) अंतर्गत भुसंपादन करण्यासाठी प्रकरणातील संयुक्त",
        "मोजणी अहवालनुसार अधिसुचना शासनाच्या राजपत्रात प्रसिध्द करण्याबाबत."
      ],

      references: [
        "संदर्भ:- 1.मा.जिल्हाधिकारी,बुलडाणा यांचे पत्र क्र./कावि/कक्ष 7/प्रअभुसं/429/2023 दि.11 एप्रिल 2023.",
        "2.रेल्वे दुरुस्ती कायदा 2008 (THE RAILWAYS (AMENDMENT) ACT,2008)",
        "3.भारत सरकारचे राजपत्र दि.25 एप्रिल 2023",
        "4.उपअधिक्षक,भुमी अभिलेख,जळगांव जा. यांचे संयुक्त मोजणी अहवाल जा.क्र.2193 दि.24/11/2023.",
        "5.उपअधिक्षक,भुमी अभिलेख,जळगांव जा. यांचे संयुक्त मोजणी अहवाल जा.क्र.2192 दि.24/11/2023"
      ],

      mainContent: [
        "मा.जिल्हाधिकारी,बुलडाणा भुसंपादन विभाग यांचे उक्त संदर्भीय आदेशानुसार अकोला खंडवा रेल्वे प्रकल्पाअंतर्गत जळगांव जा. व संग्रामपुर तालुक्यातील जमीन संपादन करण्याबाबतचा प्रस्ताव प्राप्त झाला असून खालील प्रकरणात रेल्वे दुरुस्ती कायदा 2008(THE RAILWAYS (AMENDMENT) ACT,2008) अंतर्गत कलम 20 (A)/20(D) मधील तरतुदीनुसार कार्यकारी अभिय्रता,दक्षीण मध्ये रेल्वे बांधकाम-2 अकोला यांचेकडील खालील प्रकरणातील भुसंपादनाबाबत अंतिम संयुक्त मोजणी करण्यात आली असून उपअधिक्षक,भुमी अभिलेख संग्रामपुर. यांचे संयुक्त मोजणी अहवालानुसार संग्रामपुर तालुक्यातील खालील प्रकरणातील भुधारक व त्यांचे संपादनाचे क्षेत्र निश्चित करण्यात आले आहे. त्यानुसार सदर अधिसुचना शासनाचे राजपत्रात प्रसिध्द करुन मुद्रित केलेल्या राजपत्राच्या 5 प्रती या कार्यालयास पाठविण्याबाबत विनंती आहे.प्रसिध्दीसाठी यासोबत अधिसुचनेची प्रत जोडली आहे."
      ],

      enclosure: "सहपत्र:- अधिसुचना तीन प्रतीत.",

      signature: "(शैलेष काळे)",
      designation: "उपविभागीय अधिकारी,तथा भुसंपादन अधिकारी,जळगांव जा.",

      copyTo: [
        "प्रतिलीपी:-",
        "1.मा.जिल्हाधिकारी,बुलडाणा (भुसंपादन विभाग) यांना माहिती करीता सविनय सादर.",
        "2.कार्यकारी अभियंता,दक्षिण मध्य रेल्वे बांधकाम-2 अकोला यांना माहितीकरीता अग्रेषित.",
        "3.तहसिलदार,जळगांव जा/संग्रामपुर यांना आवश्यक कार्यवाहीसाठी अग्रेषित.",
        "4.उप अधिक्षक,भुमी अभिलेख, जळगांव जा/संग्रामपुर यांना माहिती व आवश्यक कार्यवाहीस अग्रेषित.",
        "5.दुय्यम निंबधक,जळगांव जा./संग्रामपुर यांना माहिती व आवश्यक कार्यवाहीस अग्रेषित.",
        "5.मंडळ अधिकारी-----------------/तलाठी----------------- यांना पुढील कार्यवाहीसाठी अग्रेषित.त्यांनी",
        "सदरची अधिसुचना स्थानिक स्तरावर तलाठी चावडी/ ग्रामपंचायत कार्यालय येथे प्रसिध्द करुन त्या",
        "संबंधीचा प्रसिध्दी अहवाल या कार्यालयास सादर करावा."
      ],

      finalDesignation: "उपविभागीय अधिकारी,तथा भुसंपादन अधिकारी,जळगांव जा."
    }
  };

  const t20A = DATA.notification20A[lang];
  // const t20D = DATA.notification20D[lang];
  const content = {
    mr: {
      heading: "अधिसूचना 20(A)",
      para1: "रेल्वे दुरुस्ती कायदा 2008 मधिल कलम 20(A)/20(D) अंतर्गत अधिसुचना",
    },
    hi: {
      heading: "अधिसूचना 20(A)",
      para1: "रेलवे संशोधन अधिनियम 2008 की धारा 20(A)/20(D) के अंतर्गत अधिसूचना",
    },
    en: {
      heading: "Notification 20(A)",
      para1: "Notification under section 20(A)/20(D) of the Railways (Amendment Act, 2008)",
    }
  };

  /* ===================== UI ===================== */
  return (
    <div className="railway-doc">
      {/* Language Switch */}
      <div className="lang-bar no-print">
        <div className="lang-left">
          {["mr", "hi", "en"].map(l => (
            <button
              key={l}
              onClick={() => setLang(l)}
              className={lang === l ? "active" : ""}
            >
              {l === "mr" ? "मराठी" : l === "hi" ? "हिंदी" : "English"}
            </button>
          ))}
        </div>

        <div className="lang-right">
          <button onClick={() => window.print()}>Print</button>
        </div>
      </div>

      {/* ================= HEADER ================= */}
      <div className="document-header">
        {/* CENTER HEADING */}
        <div className="header-center">
          <h3 className="bold">{t20A.subHeading}</h3>
          <p className="small">{t20A.engSubHeading}</p>
        </div>
        {/* Office Details - Positioned Right */}
        <div className="office-details-right">
          <div className="office-block">

            <p className="bold office-ref">{t20A.officeRef}</p>
            <p>{t20A.officeName}</p>
            <p>{t20A.officeLocation}</p>
            <p>{t20A.date}</p>
          </div>
        </div>
      </div>

      {/* ================= 20(A) NOTIFICATION ================= */}
      <h2 className="center bold mt">{t20A.heading}</h2>

      {t20A.paragraphs.map((p, i) => (
        <p key={i} className="justified">{p}</p>
      ))}

      {/* ================= SCHEDULE 1 ================= */}
      <h3 className="bold mt center">{t20A.schedule1}</h3>
      <p className="center">{t20A.schedule1Desc}</p>

      {/* Village Tables */}
      {DATA.villages.map((v, i) => (
        <div key={i} className="page-break">
          <p className="bold mt">{v.caseNo[lang]}</p>

          <p className="bold">
            {t20A.village}: {v.name[lang]} | {t20A.taluka}: {v.taluka[lang]} | {t20A.district}: {v.district[lang]}
          </p>

          <table className="data-table">
            <thead>
              <tr>
                {t20A.tableHeaders.map((h, idx) => (
                  <th key={idx}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {v.rows.map((r, ri) => (
                <tr key={ri}>
                  {r.map((c, ci) => (
                    <td key={ci}>{c}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      {/* ================= SCHEDULE 2 ================= */}
      <div className="page-break">
        <h3 className="bold mt center">{t20A.schedule2}</h3>
        <h4 className="center">{t20A.schedule2Title}</h4>

        <div className="mt">
          <p className="bold">{t20A.schedule2Data.projectName}</p>
          <p className="bold mt-small">{t20A.schedule2Data.acquisitionAgency}</p>
          <p className="bold mt-small">{t20A.schedule2Data.socialBenefits}</p>
        </div>

        <div className="signature-section mt">
          <p className="right bold">{t20A.signature}</p>
          <p className="right bold">{t20A.designation}</p>
        </div>
      </div>



      {/* ================= MARATHI-ONLY OFFICE LETTER ================= */}
      <div className="page-break">
        {/* Send to Project Incharge Button */}
        <div className="no-print right mb">
          <button
            onClick={() => {
              setshowSendToProjectInchargeModal(true);
            }}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors"
          >
            <ArrowLeft size={16} />
            {translations[language]?.SendToProjectIncharge || 'Send to Project Incharge'}
          </button>
        </div>

        <div className="center mb">
          <h3 className="bold">{DATA.officeLetter.heading}</h3>
          <p className="small">{DATA.officeLetter.emailPhone}</p>
          <p className="mt-small">{DATA.officeLetter.refNo}</p>
          <p>{DATA.officeLetter.date}</p>
        </div>

        {DATA.officeLetter.recipients.map((p, i) => (
          <p key={i}>{p}</p>
        ))}

        <div className="mt">
          {DATA.officeLetter.subject.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="mt">
          {DATA.officeLetter.references.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="mt">
          {DATA.officeLetter.mainContent.map((p, i) => (
            <p key={i} className="justified">{p}</p>
          ))}
        </div>

        <p className="mt">{DATA.officeLetter.enclosure}</p>

        <div className="signature-section mt">
          <p className="right bold">{DATA.officeLetter.signature}</p>
          <p className="right bold">{DATA.officeLetter.designation}</p>
        </div>

        <div className="mt">
          {DATA.officeLetter.copyTo.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <p className="right bold mt">{DATA.officeLetter.finalDesignation}</p>
      </div>

      {/* ================= STYLES ================= */}
      <style>{`
        .railway-doc {
          font-family: "Noto Serif Devanagari", "Shippori Mincho", serif;
          font-size: 14px;
          line-height: 1.6;
          max-width: 210mm;
          margin: 0 auto;
          padding: 20px;
          background: white;
        }
        
        h2, h3, h4 {
          margin: 15px 0;
        }
        
        p {
          margin: 8px 0;
        }
        
        .data-table {
          width: 100%;
          border-collapse: collapse;
          margin: 15px 0;
          font-size: 12px;
        }
        
        .data-table th, .data-table td {
          border: 1px solid #000;
          padding: 6px 4px;
          text-align: center;
          vertical-align: middle;
        }
        
        .data-table th {
          background-color: #f0f0f0;
          font-weight: bold;
        }
        
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: bold; }
        .justified { text-align: justify; }
        
        .header-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 30px;
          padding-bottom: 15px;
          border-bottom: 2px solid #dee2e6;
        }
        
        .header-left-section {
          flex: 1;
          text-align: left;
        }
        
        .header-left-section h3 {
          margin: 0 0 8px 0;
          font-size: 16px;
        }
        
        .header-left-section p {
          margin: 4px 0;
        }
        
        .header-right-section {
          text-align: right;
          min-width: 380px;
          padding-left: 20px;
        }
        
        .header-right-section p {
          margin: 3px 0;
          line-height: 1.6;
        }
        
        .mt { margin-top: 70px; }
        .mt-small { margin-top: 10px; }
        .mb { margin-bottom: 20px; }
        .small { font-size: 12px; }
        
        .signature-section {
          margin-top: 30px;
          margin-right: 50px;
        }
        
        .page-break {
          page-break-before: always;
          padding-top: 20px;
        }
        
.lang-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.lang-left button {
  margin-right: 8px;
}

.lang-right button {
  background: #2563eb; /* blue */
  color: #fff;
  padding: 6px 14px;
  border-radius: 6px;
}
        

        
        .lang-bar button:hover {
          background: rgba(255,255,255,0.2);
          border-color: rgba(255,255,255,0.5);
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
        

        
        .send-button {
          padding: 12px 24px;
          background: #28a745;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
          transition: all 0.3s ease;
        }
        
        .send-button:hover {
          background: #218838;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          transform: translateY(-2px);
        }
        
        .send-button:active {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        
        @media print {
          .no-print { 
            display: none; 
          }
          
          .railway-doc {
            padding: 0;
            max-width: 100%;
          }
          
          .page-break {
            page-break-before: always;
          }
        }
        
        @page {
          size: A4;
          margin: 20mm;
        }
          .document-header {
  position: relative;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #dee2e6;
}

.office-details-right {
text-align: right;
  width: 100%;
  max-width: 380px;
  justify-self: end;
}

.office-details-right p {
  display: block;
  width: 100%;
  margin: 3px 0;
}

.main-heading-center {
  padding-right: 400px;
  
}

.main-heading-center h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.main-heading-center p {
  margin: 4px 0;
  
}
  .document-header {
  position: relative;

}

.main-heading-center {
  text-align: center;
  padding-right: 400px; /* Space for office details */
  padding-top: 10px;
}

.main-heading-center h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.main-heading-center p {
  margin: 4px 0;
}

.office-details-right {
  position: absolute;
}

.office-details-right p {
  margin: 3px 0;
  line-height: 1.6;
  font-size: 14px;
}
  .document-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: none;
}


/* ===== LANGUAGE BAR ===== */
.lang-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

/* LEFT LANGUAGE BUTTONS */
.lang-left button {
  margin-right: 8px;
  padding: 8px 18px;
  background-color: #2563eb;   /* BLUE */
  color: #ffffff;              /* WHITE TEXT */
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.lang-left button:hover {
  background-color: #1d4ed8;
}

/* ACTIVE LANGUAGE */
.lang-left button.active {
  background-color: #1e40af;
}

/* RIGHT PRINT BUTTON */
.lang-right button {
  padding: 8px 18px;
  background-color: #2563eb;   /* BLUE */
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.lang-right button:hover {
  background-color: #1d4ed8;
}

/* TRUE CENTER HEADING */
.header-center {
  grid-column: 1 / -1;
  text-align: center;
}

.header-center h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.header-center p {
  margin: 4px 0;
  font-size: 12px;
}

/* RIGHT SIDE OFFICE BLOCK */
.office-details-right {

  justify-self: end;
  text-align: right;
  margin-top: 50px;
}

.office-details-right p {
  margin: 3px 0;
  font-size: 14px;
}
.office-ref {
  margin-top: 10px;
}

      `}</style>
      {/* Send to ProjectIncharge Modal - Works for both sections */}
      {showSendToProjectInchargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4">
                {translations[language]?.SendToProjectIncharge}
              </h2>

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectProjectIncharge}*
                  </label>
                  <select
                    value={selectedUserProjectIncharge}
                    onChange={(e) => setselectedUserProjectIncharge(e.target.value)}
                    disabled={loadingusersProjectIncharge}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersProjectIncharge ? 'Loading Users...' : 'Select User'}
                    </option>
                    {usersProjectInchargeAll.map((user) => (
                      <option key={user.usr_id} value={user.usr_id}>
                        {user.full_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.REMARKS}
                  </label>
                  <textarea
                    value={remarksProjectIncharge}
                    onChange={(e) => setremarksProjectIncharge(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.UploadDocument}*
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentProjectIncharge(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToProjectInchargeModal(false);
                    setselectedUserProjectIncharge('');
                    setremarksProjectIncharge('Approved');
                    setselectedDocumentProjectIncharge(null);
                    setRequestedFundPI('');
                    setDatePI('');
                    setSelectedSectionType(null); // Reset section type
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToProjectIncharge}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendToProjectIncharge}
                  disabled={sendingToProjectIncharge || !selectedUserProjectIncharge || !selectedDocumentProjectIncharge || !requestedFundPI || !datePI}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToProjectIncharge ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.send}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Railway20ANotification;